import { render, staticRenderFns } from "./SubmitComment.vue?vue&type=template&id=ac69774c&scoped=true&"
import script from "./SubmitComment.vue?vue&type=script&lang=js&"
export * from "./SubmitComment.vue?vue&type=script&lang=js&"
import style0 from "./SubmitComment.vue?vue&type=style&index=0&id=ac69774c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac69774c",
  null
  
)

export default component.exports